var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin OH
 * @contact hjoh@detech.co.kr
 * @date 2023-09-26
 * @brief SEI 운영관리 - 데이터동의관리 개발
 *
 ********************************************************************/
import { useEffect, useMemo, useRef, useState } from "react";
// recoil
import { useAsync } from "react-async";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { loadingBoxState } from "../../../../recoil/menuState";
import { reLoad, userInfoLoginState } from "../../../../recoil/userState";
// utils
import { alertState, curAdminTreeState } from "../../../../recoil/assessmentState";
import * as CONST from "../../../../utils/Const";
import * as HTTPUTIL from "../../../../utils/api/HttpUtil";
import * as CUTIL from "../../../../utils/commUtils";
import { DataConsentList } from "@components/dashBoard/operationmanagement/dataconsent/DataConsentList";
import { Trans } from "react-i18next";
import { langId } from "../../../../recoil/langState";
import { useTrans } from "../../../../utils/langs/useTrans";
import EhpPostCode from "../../../common/postcode/EhpPostCode";
function DataConsentMain(props) {
    var _a;
    const t = useTrans();
    const scrollRef = useRef(null);
    // recoil
    const userInfo = useRecoilValue(userInfoLoginState);
    const recoilTree = useRecoilValue(curAdminTreeState);
    const setIsLoadingBox = useSetRecoilState(loadingBoxState);
    const [reload, setReload] = useRecoilState(reLoad);
    const [alerts, setAlerts] = useRecoilState(alertState);
    const langIds = useRecoilValue(langId);
    // props
    const { handleOpenPop } = props;
    const [repop, setRepop] = useState(false);
    const [fileName, setFileName] = useState("");
    const [errorList, setErrorList] = useState([]);
    const [addressItem, setAddressItem] = useState(null);
    const [zone, setZone] = useState("");
    const [subZone, setSubZone] = useState(null);
    const [subZnoeAddress, setsubZoneAddress] = useState(null);
    const [isPopupPostCode, setIsPopupPostCode] = useState(false);
    const [successList, setSuccessList] = useState([]);
    const [failList, setFailList] = useState([]);
    useEffect(() => {
        handleOpenPop("pop-postcode", _jsx(EhpPostCode, { isPopup: isPopupPostCode, setIsPopup: setIsPopupPostCode, setAddress: callbackSetZoneInfoAddress, notInPop: "notInPop" }));
        //성공 실패
        handleOpenPop("pop-finish-ok", _jsx(FinishPop, { successList: successList, failList: failList, repop: repop, htmlClose: _jsxs(_Fragment, { children: [_jsx("h1", { children: fileName }), _jsx("button", Object.assign({ className: "btn btn-close js-close", onClick: (e) => Close("pop-finish-ok") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uB2EB\uAE30" })) }))] }) }));
    }, [isPopupPostCode, successList, failList, repop, fileName]);
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setRepop(true);
    }
    // 기본 주소
    let appPath = `?zoneId=${recoilTree.zone.zoneId}`;
    // 기기 등록 관리 목록  API
    const { data: data } = useAsync({
        promiseFn: HTTPUTIL.PromiseHttp,
        httpMethod: "GET",
        appPath: `/energyreport/addresses${appPath}`,
        appQuery: {},
        userToken: userInfo.loginInfo.token,
        watch: appPath + reload + langIds,
    });
    useEffect(() => {
        if (data) {
            if (data.codeNum == CONST.API_200) {
                setAddressItem(Object.assign(Object.assign({}, data.body), { custInfo: data.body.custNo }));
            }
            else {
                setAddressItem(null);
                if (!recoilTree.subZone.subZoneId) {
                    setAlerts(Object.assign(Object.assign({}, alerts), { divTag: "상세사업을 선택하세요.", callBack: () => {
                            CUTIL.jsclose_Popup(CONST.POP_ALERT);
                        } }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                }
            }
            scrollRef.current.scrollTop = 0;
        }
    }, [data, reload, langIds]);
    function onClickPostCode(e, item) {
        setIsPopupPostCode(true);
        CUTIL.jsopen_Popup(e);
        if (!item) {
            setErrorList(errorList.filter((err) => err.field !== "subZoneAddrees"));
            setSubZone(item);
        }
        else if (item == "zone") {
            setErrorList(errorList.filter((err) => err.field !== "addrees"));
            setZone(item);
            setSubZone(item);
        }
        else {
            setZone("");
            setSubZone(item);
        }
    }
    function callbackSetZoneInfoAddress(val) {
        if (!subZone) {
            setsubZoneAddress(val);
        }
        else if (zone.length > 0) {
            setAddressItem(Object.assign(Object.assign({}, addressItem), { zoneAddress: val.address }));
        }
        else {
            setAddressItem(Object.assign(Object.assign({}, addressItem), { subZone: addressItem.subZone.map((smenu) => smenu.subZoneIdPk === subZone.subZoneIdPk
                    ? Object.assign(Object.assign({}, smenu), { address: val.address, bjdongCd: val.bjdongCd, bname: val.bname, bun: val.bun, ji: val.ji, postalCode: val.postalCode, sigunguCd: val.sigunguCd }) : smenu) }));
        }
    }
    // 고객 정보 수정
    function onChangeCustNo(e) {
        setErrorList(errorList.filter((err) => err.field !== "custNo"));
        setAddressItem(Object.assign(Object.assign({}, addressItem), { custInfo: e.target.value.replace(/[^0-9]/g, "") }));
    }
    //사업장 주소변경
    function AddressEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/product/zone/${recoilTree.zone.zoneId}`,
                appQuery: {
                    zoneName: recoilTree.zone.zoneName,
                    address: addressItem ? addressItem.zoneAddress : null,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.사업장주소가변경되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setIsLoadingBox(false);
                }
                else {
                    // need error handle
                    if (data.errorList !== null) {
                        setErrorList(data.errorList);
                    }
                    else {
                        setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: CONST.ERROR_MSG }));
                        CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    }
                    setIsLoadingBox(false);
                }
            }
        });
    }
    //상세 사업장 주소만 변경
    function SubZoneAddressAdd(item) {
        return __awaiter(this, void 0, void 0, function* () {
            setIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "POST",
                appPath: `/energyreport/address`,
                appQuery: {
                    address: item.address,
                    sigunguCd: item.sigunguCd,
                    bjdongCd: item.bjdongCd,
                    bun: item.bun,
                    ji: item.ji,
                    postalCode: item.postalCode,
                    bname: item.bname,
                    subZoneId: recoilTree.subZone.subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "상세 사업장 주소가 변경 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setIsLoadingBox(false);
                }
                else {
                    setIsLoadingBox(false);
                    setErrorList([{ field: "subZoneAddress", msg: t("라벨.필수항목을입력하지않으셨습니다") }]);
                }
            }
        });
    }
    function SubZoneAddressEdit(item) {
        return __awaiter(this, void 0, void 0, function* () {
            setIsLoadingBox(true);
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyreport/address/${item.addressId}`,
                appQuery: {
                    address: item.address,
                    sigunguCd: item.sigunguCd,
                    bjdongCd: item.bjdongCd,
                    bun: item.bun,
                    ji: item.ji,
                    postalCode: item.postalCode,
                    bname: item.bname,
                    subZoneId: item.subZoneId,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: "상세 사업장 주소가 변경 되었습니다." }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setIsLoadingBox(false);
                }
                else {
                    setIsLoadingBox(false);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    // 주소만 변경
    function CustNoEdit(e) {
        return __awaiter(this, void 0, void 0, function* () {
            setIsLoadingBox(true);
            let addInfo = null;
            addressItem.subZone.map((item) => (addInfo = item));
            let data = null;
            data = yield HTTPUTIL.PromiseHttp({
                httpMethod: "PUT",
                appPath: `/energyreport/address/custInfo`,
                appQuery: {
                    subZoneIdPk: addInfo.subZoneIdPk,
                    custNo: addressItem.custInfo,
                },
                userToken: userInfo.loginInfo.token,
            });
            if (data) {
                if (data.codeNum == CONST.API_200) {
                    setReload(true);
                    setAlerts(Object.assign(Object.assign({}, alerts), { type: CONST.TYPE_NONE, divTag: t("라벨.고객정보가등록/변경되었습니다") }));
                    CUTIL.jsopen_AlertPopup(CONST.POP_ALERT);
                    setReload(false);
                    setIsLoadingBox(false);
                }
                else {
                    setIsLoadingBox(false);
                    setErrorList(data.errorList);
                }
            }
        });
    }
    //성공 실패 팝업
    function FinishPops(e, success, fail, fileName) {
        setSuccessList(success);
        setFailList(fail);
        setFileName(fileName);
        CUTIL.jsopen_Popup(e);
    }
    // 데이터 등록 PDF 가이드
    function AllDataDownload(e) {
        fetch("https://repoehp.blob.core.windows.net/repoehp-item/help/데이터_등록_PDF_가이드.pdf").then((response) => {
            response.blob().then((blob) => {
                const fileURL = window.URL.createObjectURL(blob);
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.download = "데이터_등록_PDF_가이드";
                alink.click();
                window.URL.revokeObjectURL(fileURL);
            });
        });
    }
    //이미지 리스트
    const dataConsentList = [
        Array.from({ length: 8 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_data0${i}.png`),
            alt: `${t("라벨.서비스정보제공동의")}`,
        })),
        Array.from({ length: 8 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_old_data0${i}.png`),
            alt: ` ${t("라벨.한전EDS과거청구요금")}`,
        })),
        Array.from({ length: 8 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_usekwh_data0${i}.png`),
            alt: `${t("라벨.한전EDS과거전력사용량")}`,
        })),
        Array.from({ length: 8 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_pf_data0${i}.png`),
            alt: `${t("라벨.고객역률데이터")}`,
        })),
        Array.from({ length: 6 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_data_consent/img_scada_data0${i}.png`),
            alt: `SCADA ${t("라벨.데이터")}`,
        })),
        Array.from({ length: 6 }, (v, i) => ({
            id: i,
            name: `${i + 1}번째이미지`,
            url: require(`/static/img/img_data_consent/img_mes_data0${i}.png`),
            alt: `MES ${t("라벨.데이터등록")}`,
        })),
    ];
    const dataConsetOpt = useMemo(() => [
        {
            title: `1. ${t("라벨.서비스정보제공동의")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/서비스 정보 제공 동의.pdf",
            downloadExcel: false,
            uploadExcel: false,
        },
        {
            title: `2. ${t("라벨.한전EDS과거청구요금")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/과거 청구요금.pdf",
            downloadExcel: false,
            uploadExcel: true,
            httpMethod: "POSTF",
            appPath: `/energyreport/file/bill?custNo=${addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo}`,
        },
        {
            title: `3. ${t("라벨.한전EDS과거전력사용량")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/과거 전력사용량.pdf",
            downloadExcel: false,
            uploadExcel: true,
            httpMethod: "POSTF",
            appPath: `/energyreport/file?custNo=${addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo}`,
        },
        {
            title: `4. ${t("라벨.고객역률데이터")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/고객 역률 데이터.pdf",
            downloadExcel: true,
            uploadExcel: true,
            excelUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/item/마이데이터(역률)양식.xlsx",
            httpMethod: "POST",
            appPath: `/energyreport/file/pf?custNo=${addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo}`,
        },
        {
            title: `5. SCADA ${t("라벨.데이터")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/SCADA 데이터 등록.pdf",
            downloadExcel: true,
            uploadExcel: true,
            excelUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/item/SCADA_양식.xlsx",
            httpMethod: "POSTF",
            appPath: `/energyreport/file/scada?custNo=${addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo}`,
        },
        {
            title: ` 6. MES ${t("라벨.데이터등록")}`,
            pdfUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/help/MES 데이터 등록.pdf",
            downloadExcel: true,
            uploadExcel: true,
            excelUrl: "https://repoehp.blob.core.windows.net/repoehp-rel-item/item/MES_양식.xlsx",
            httpMethod: "POSTF",
            appPath: `/energyreport/file/mes?custNo=${addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo}`,
        },
    ], [addressItem]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ ref: scrollRef, className: "box__body data-manage" }, { children: [_jsx("div", Object.assign({ className: "top-img" }, { children: _jsx("div", Object.assign({ className: "text-wrap" }, { children: _jsxs(Trans, Object.assign({ i18nKey: "운영관리.데이터동의헤더" }, { children: [_jsx("p", Object.assign({ className: "tit" }, { children: "\uD504\uB9AC\uBBF8\uC5C4 \uC11C\uBE44\uC2A4 \uC81C\uACF5\uC744 \uC704\uD574 \uCD94\uAC00\uC801\uC778 \uB370\uC774\uD130 \uB4F1\uB85D\uC774 \uD544\uC694\uD569\uB2C8\uB2E4." })), _jsxs("p", Object.assign({ className: "txt" }, { children: ["'Smart Energy Insight'\uB97C \uD48D\uC131\uD558\uAC8C \uC774\uC6A9\uD558\uAE30 \uC704\uD574\uC11C\uB294 \uC544\uB798\uC640 \uAC19\uC740 \uC808\uCC28\uAC00 \uD544\uC694\uD569\uB2C8\uB2E4. \uD68C\uC6D0\uB2D8\uAED8\uC11C\uB294 \uC120\uD0DD\uC801\uC73C\uB85C \uC808\uCC28\uB97C \uC218\uD589\uD558\uC5EC \uC11C\uBE44\uC2A4\uB97C \uC774\uC6A9\uD558\uC2E4 \uC218 \uC788\uC9C0\uB9CC, \uBCF4\uB2E4", _jsx("br", {}), "\uD48D\uBD80\uD55C \uC11C\uBE44\uC2A4\uC640 \uCEE8\uD150\uCE20\uB97C \uC774\uC6A9\uD558\uAE30 \uC704\uD574\uC11C \uBAA8\uB4E0 \uC808\uCC28\uB97C \uC218\uD589\uD558\uC2DC\uAE38 \uAD8C\uC7A5\uB4DC\uB9BD\uB2C8\uB2E4."] })), _jsx("div", Object.assign({ className: "flex-inline right" }, { children: _jsx("button", Object.assign({ type: "button", className: "btn-basic", onClick: (e) => AllDataDownload(e) }, { children: _jsx("span", Object.assign({ className: "icon-down" }, { children: "\uB370\uC774\uD130 \uB4F1\uB85D PDF \uAC00\uC774\uB4DC" })) })) }))] })) })) })), !(addressItem || recoilTree.subZone.subZoneId) ? (_jsx("div", Object.assign({ className: "nodata" }, { children: _jsx("p", Object.assign({ className: "nodata__txt" }, { children: "\uC0C1\uC138\uC0AC\uC5C5\uC7A5\uC774 \uC5C6\uC2B5\uB2C8\uB2E4." })) }))) : (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "info__input" }, { children: [_jsx("div", Object.assign({ className: "page-top mb-40" }, { children: _jsxs("h3", { children: [_jsx("span", { children: t("라벨.고객정보확인") }), _jsxs("span", Object.assign({ className: "txt-info" }, { children: [_jsx("span", Object.assign({ className: "txt-red mr-4" }, { children: "*" })), t("라벨.필수사항입력")] }))] }) })), _jsx("div", Object.assign({ className: "content__info" }, { children: _jsxs("ul", Object.assign({ className: "form__input" }, { children: [_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit" }, { children: t("라벨.회사명") })), _jsx("p", Object.assign({ className: "txt" }, { children: addressItem ? addressItem.companyName : "-" }))] }), _jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.사업장주소"), " ", addressItem && addressItem.zoneName ? `(${addressItem.zoneName})` : ""] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-8" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.직접입력"), className: errorList.filter((err) => err.field === "address").length > 0 ? "input-error" : "", value: addressItem ? addressItem.zoneAddress : "", readOnly: true, "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e, "zone") }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e, "zone") }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic wmin-74 p-0", onClick: (e) => AddressEdit(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })) }))] }), addressItem && addressItem.subZone ? (addressItem.subZone.map((address, idx) => (_jsxs("li", { children: [_jsxs("p", Object.assign({ className: "tit" }, { children: [t("라벨.상세사업장주소"), " ", `(${address.subZoneName})`] })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-8" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.직접입력"), className: errorList.filter((err) => err.field === "subZoneName").length > 0 ? "input-error" : "", value: address.address != null ? address.address : "", readOnly: true, "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e, address) }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e, address) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic wmin-74 p-0", onClick: (e) => SubZoneAddressEdit(address) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })) }))] }, "subAddress_" + idx.toString())))) : (_jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.상세사업장주소") })), _jsx("div", Object.assign({ className: "input__area" }, { children: _jsxs("div", Object.assign({ className: "flex-inline gap-8" }, { children: [_jsxs("div", Object.assign({ className: "box__search" }, { children: [_jsx("input", { type: "text", placeholder: t("라벨.직접입력"), className: errorList.filter((err) => err.field === "subZoneAddress").length > 0
                                                                                ? "input-error"
                                                                                : "", value: subZnoeAddress ? subZnoeAddress.address : "", readOnly: true, "data-pop": "pop-postcode", onFocus: (e) => onClickPostCode(e, null) }), _jsx("button", Object.assign({ type: "button", className: "btn btn-search js-open", "data-pop": "pop-postcode", onClick: (e) => onClickPostCode(e, null) }, { children: _jsx("span", Object.assign({ className: "hide" }, { children: "\uC870\uD68C" })) }))] })), _jsx("button", Object.assign({ type: "button", className: "btn-basic wmin-74 p-0", onClick: (e) => SubZoneAddressAdd(subZnoeAddress) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })) }))] })), _jsxs("li", { children: [_jsx("p", Object.assign({ className: "tit star" }, { children: t("라벨.고객번호") })), _jsxs("div", Object.assign({ className: "input__area" }, { children: [_jsxs("div", Object.assign({ className: "flex-inline gap-8" }, { children: [_jsx("input", { type: "text", readOnly: !addressItem ? true : addressItem && !addressItem.subZone ? true : false, maxLength: 10, className: errorList.filter((err) => err.field === "custNo").length > 0 ? "input-error" : "", value: addressItem && addressItem.custInfo !== null ? addressItem.custInfo : "", placeholder: t("라벨.한전고객번호입력"), onChange: (e) => onChangeCustNo(e) }), _jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "custNo").map((err) => err.msg) })), _jsx("button", Object.assign({ type: "button", disabled: !addressItem
                                                                            ? true
                                                                            : addressItem && !addressItem.subZone
                                                                                ? true
                                                                                : ((_a = addressItem === null || addressItem === void 0 ? void 0 : addressItem.custInfo) === null || _a === void 0 ? void 0 : _a.length) == 10
                                                                                    ? false
                                                                                    : true, className: "btn-basic wmin-74 p-0", onClick: (e) => CustNoEdit(e) }, { children: _jsx("span", { children: t("라벨.저장") }) }))] })), errorList.filter((err) => err.field === "custNo").length <= 0 ? (_jsx("p", Object.assign({ className: "txt-info mb-0 w278" }, { children: t("라벨.데이터동의관리정보") }))) : (_jsx("p", Object.assign({ className: "input-errortxt" }, { children: errorList.filter((err) => err.field === "custNo").map((err) => err.msg) })))] }))] })] })) }))] })), dataConsentList.map((item, idx) => (_jsx(DataConsentList, { imgList: item, option: dataConsetOpt[idx], disabled: !addressItem ? true : !!(addressItem && addressItem.custNo == null), custNo: (addressItem === null || addressItem === void 0 ? void 0 : addressItem.custNo) || "", FinishPops: FinishPops }, `dataConsent_${idx}`)))] }))] })) }));
}
export default DataConsentMain;
function FinishPop(props) {
    const t = useTrans();
    // props
    const { successList, failList, repop } = props;
    //
    const [togles, setTogles] = useState(false);
    useEffect(() => {
        setTogles(false);
    }, [successList, failList, repop]);
    function Close(id) {
        CUTIL.jsclose_Popup(id);
        setTogles(false);
    }
    return (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: "popup__body" }, { children: [_jsx("div", Object.assign({ className: "tbl__top" }, { children: _jsxs("ul", Object.assign({ className: "tab__button" }, { children: [_jsx("li", Object.assign({ className: togles ? "" : "on", onClick: (e) => setTogles(false) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault(), className: "green" }, { children: t("라벨.성공") })) })), _jsx("li", Object.assign({ className: togles ? "on" : "", onClick: (e) => setTogles(true) }, { children: _jsx("a", Object.assign({ href: "#", onClick: (e) => e.preventDefault(), className: "red" }, { children: t("라벨.실패") })) }))] })) })), !togles ? (_jsx("div", Object.assign({ className: "tbl-list dark scrollH h662 pr-0 mr-0" }, { children: _jsxs("table", Object.assign({ summary: "No.,\uACE0\uAC1D\uBC88\uD638,\uCCAD\uAD6C\uB144\uC6D4,\uC9C0\uC0C1\uC5ED\uB960,\uC9C4\uC0C1\uC5ED\uB960 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC5C5\uB85C\uB4DC\uC131\uACF5 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC5C5\uB85C\uB4DC \uC131\uACF5 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "13%" } }), _jsx("col", { style: { width: "19%" } }), _jsx("col", { style: { width: "18%" } }), _jsx("col", { style: { width: "25%" } }), _jsx("col", { style: { width: "25%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.지상역률") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.날짜") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.지상역률") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.진상역률") }) }))] }) }), _jsx("tbody", { children: successList.length > 0 &&
                                        successList
                                            .sort((a, b) => (a.excelNo > b.excelNo ? 1 : -1))
                                            .map((list, idx) => (_jsxs("tr", { children: [_jsx("td", { children: list.excelNo }), _jsx("td", { children: list.custNo }), _jsx("td", { children: list.billYm }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.jiPwrfact })) }), _jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: list.jnPwrfact })) })] }, "dataSuccess_" + idx.toString()))) })] })) }))) : (
                    // <!--실패테이블>-->
                    _jsx("div", Object.assign({ className: "tbl-list scrollH dark h662 pr-0 mr-0" }, { children: _jsxs("table", Object.assign({ summary: "No.,Excel No.,\uD615\uBA85,\uC2DC\uB9AC\uC5BC\uBC88\uD638,\uC2E4\uD328\uC0AC\uC720 \uD56D\uBAA9\uC73C\uB85C \uAD6C\uC131\uB41C \uC5C5\uB85C\uB4DC \uC2E4\uD328 \uB9AC\uC2A4\uD2B8 \uC785\uB2C8\uB2E4." }, { children: [_jsx("caption", { children: "\uC5C5\uB85C\uB4DC \uC2E4\uD328 \uB9AC\uC2A4\uD2B8" }), _jsxs("colgroup", { children: [_jsx("col", { style: { width: "10%" } }), _jsx("col", { style: { width: "13%" } }), _jsx("col", { style: { width: "17%" } }), _jsx("col", { style: { width: "60%" } })] }), _jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: "Excel No." }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.날짜") }) })), _jsx("th", Object.assign({ scope: "col" }, { children: _jsx("span", { children: t("라벨.실패사유") }) }))] }) }), _jsx("tbody", { children: failList.length > 0 &&
                                        failList
                                            .sort((a, b) => (a.excelNo > b.excelNo ? 1 : -1))
                                            .map((list, idx) => (_jsxs("tr", { children: [_jsx("td", { children: idx + 1 }), _jsx("td", { children: list.excelNo }), _jsx("td", { children: list.billYm }), list.cause
                                                    .filter((_, i) => i == 0)
                                                    .map((err, j) => (_jsx("td", { children: _jsx("p", Object.assign({ className: "ellipsis" }, { children: err.msg })) }, "dataErr_" + j.toString())))] }, "dataFail_" + idx.toString()))) })] })) }))), _jsx("div", Object.assign({ className: "tbl__bottom" }, { children: _jsxs("p", Object.assign({ className: "result__num" }, { children: ["Total : ", _jsx("span", { children: !togles ? successList.length : failList.length })] })) }))] })), _jsx("div", Object.assign({ className: "popup__footer" }, { children: _jsx("button", Object.assign({ type: "button", className: "js-close", onClick: (e) => Close("pop-finish-ok") }, { children: _jsx("span", { children: t("라벨.확인") }) })) }))] }));
}
